module.exports = __webpack_public_path__ + "img/logo-mediana.449a3fd1.svg";